import * as z from "zod";

export const searchCustomerTags = {
  name: "searchCustomerTags" as const,
  input: z.object({ searchString: z.string() }),
  output: z.object({ tags: z.array(z.string()), total: z.number() }),
};
